import cn from "classnames";

import styles from "./Input.module.scss";

const VARIANTS = {
  dark: styles.dark,
  light: styles.light,
};

const Input = ({
  className,
  fieldClassName,
  endAdornmentClassName,
  startAdornmentClassName,
  withoutBorder,
  disabled,
  fieldDisabled,
  multiline,
  haveError,
  inputRef,
  variant = "dark",
  value,
  startAdornment,
  endAdornment,
  type,
  ...restProps
}: any) => {
  const Component = multiline ? "textarea" : "input";
  
  return (
    <div
      className={cn(
        styles.input,
        { [styles.inputDisabled]: disabled },
        className
      )}
    >
      {startAdornment && (
        <div className={cn(styles.startAdornment, startAdornmentClassName)}>
          {startAdornment}
        </div>
      )}
      {type === "color"
        && <label
          className={styles.colorWrapper}
        >
          <Component
            {...restProps}
            ref={inputRef}
            disabled={fieldDisabled || disabled}
            className={cn(
              styles.field,
              VARIANTS[variant],
              {
                [styles.fieldHaveError]: haveError,
                [styles.fieldMultiline]: multiline,
                [styles.fieldWithStartAdornment]: !!startAdornment,
                [styles.fieldWithEndAdornment]: !!endAdornment,
                [styles.fieldDisabled]: fieldDisabled,
                [styles.fieldWithoutBorder]: withoutBorder,
              },
              fieldClassName
            )}
            value={value}
            type={type}
          />
          <span className={styles.colorValue}>{value}</span>
        </label>
      }
      {type !== "color" &&
        <Component
          {...restProps}
          ref={inputRef}
          disabled={fieldDisabled || disabled}
          className={cn(
            styles.field,
            VARIANTS[variant],
            {
              [styles.fieldHaveError]: haveError,
              [styles.fieldMultiline]: multiline,
              [styles.fieldWithStartAdornment]: !!startAdornment,
              [styles.fieldWithEndAdornment]: !!endAdornment,
              [styles.fieldDisabled]: fieldDisabled,
              [styles.fieldWithoutBorder]: withoutBorder,
            },
            fieldClassName
          )}
          value={value}
          type={type}
        />
      }
      {endAdornment && (
        <div className={cn(styles.endAdornment, endAdornmentClassName)}>
          {endAdornment}
        </div>
      )}
    </div>
  );
};

export default Input;
